import { getId } from '@adalo/utils'

// Simple in-memory clipboard for action chains
let clipboardData = null
let listeners = []

export const copyActionChain = action => {
  if (!action) return

  clipboardData = JSON.parse(JSON.stringify(action))
  listeners.forEach(fn => fn())
}

export const getActionClipboard = () => clipboardData

export const hasActionClipboard = () => clipboardData !== null

export const subscribe = listener => {
  listeners.push(listener)

  return () => {
    listeners = listeners.filter(fn => fn !== listener)
  }
}

/**
 * Returns a deep clone of the clipboard data with fresh IDs
 * for all action items so they can be pasted without conflicts.
 */
export const pasteActionChain = () => {
  if (!clipboardData) return null

  const cloned = JSON.parse(JSON.stringify(clipboardData))

  if (cloned.actions) {
    cloned.actions = cloned.actions.map(item => ({
      ...item,
      id: getId(),
    }))
  }

  return cloned
}
